import React, { useState } from 'react';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonTitle,
  IonToolbar,
  IonSearchbar,
  useIonRouter
} from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';
import "./Modal.css";
import { Tipo } from '../interfaces';

// Datos (mantuve tus imports originales)

import dataArtesaniasEsp from '../data/artesanias_ext_es.json';
import dataArtesaniasMaya from '../data/artesanias_ext_may.json';
import dataArtesaniasEng from '../data/artesanias_ext_en.json';
import dataArtesaniasFren from '../data/artesanias_ext_fr.json';
import dataArtesaniasChin from '../data/artesanias_ext_ch.json';

import dataMuseosEsp from '../data/museos_nal_es.json';
import dataMuseosMaya from '../data/museos_nal_may.json';
import dataMuseosEng from '../data/museos_nal_en.json';
import dataMuseosFren from '../data/museos_nal_fr.json';
import dataMuseosChin from '../data/museos_nal_ch.json';

import dataPueblosMagicosEsp from '../data/pueblosmagicos_pos_es.json';
import dataPueblosMagicosMaya from '../data/pueblosmagicos_pos_may.json';
import dataPueblosMagicosEng from '../data/pueblosmagicos_pos_en.json';
import dataPueblosMagicosFren from '../data/pueblosmagicos_pos_fr.json';
import dataPueblosMagicosChin from '../data/pueblosmagicos_pos_ch.json';

import dataCooperativasEsp from '../data/cooperativas_es.json';
import dataCooperativasMaya from '../data/cooperativas_may.json';
import dataCooperativasEng from '../data/cooperativas_en.json';
import dataCooperativasFren from '../data/cooperativas_fr.json';
import dataCooperativasChin from '../data/cooperativas_ch.json';


import dataToursEsp from '../data/tours_es.json';
import dataToursMaya from '../data/tours_may.json';
import dataToursEng from '../data/tours_en.json';
import dataToursFren from '../data/tours_fr.json';
import dataToursChin from '../data/tours_ch.json';


import dataHospedajeEsp from '../data/hospedaje_es.json';
import dataHospedajeMaya from '../data/hospedaje_may.json';
import dataHospedajeEng from '../data/hospedaje_en.json';
import dataHospedajeFren from '../data/hospedaje_fr.json';
import dataHospedajeChin from '../data/hospedaje_ch.json';

import dataRestauranteEsp from '../data/restaurantes_es.json';
import dataRestauranteMaya from '../data/restaurantes_may.json';
import dataRestauranteEng from '../data/restaurantes_en.json';
import dataRestauranteFren from '../data/restaurantes_fr.json';
import dataRestauranteChin from '../data/restaurantes_ch.json';

import dataPlatilloQRooEsp from '../data/data_cocinaqroo_es.json';
import dataPlatilloQRooMaya from '../data/data_cocinaqroo_may.json';
import dataPlatilloQRooEng from '../data/data_cocinaqroo_en.json';
import dataPlatilloQRooFren from '../data/data_cocinaqroo_fr.json';
import dataPlatilloQRooChin from '../data/data_cocinaqroo_ch.json';


import dataTurComEsp from '../data/maya-ka-an.json';
import dataTurComMaya from '../data/maya-ka-an-lang-maya.json';
import dataTurComEng from '../data/maya-ka-an-lang-english.json';
import dataTurComFren from '../data/maya-ka-an-lang-french.json';
import dataTurComChin from '../data/maya-ka-an-lang-chinese.json';

import dataSitiosArqEsp from '../data/sitios_arqueologicos.json';
import dataSitiosArqMaya from '../data/sitios_arqueologicos_may.json';
import dataSitiosArqEng from '../data/sitios_arqueologicos_en.json';
import dataSitiosArqFren from '../data/sitios_arqueologicos_fr.json';
import dataSitiosArqChin from '../data/sitios_arqueologicos_ch.json';

import dataExpYucatan from '../data/experiencias_f1.json';
import dataSabYucatan from '../data/datasabores_f1.json';

// Componentes (mantengo nombres originales)
import CardArq from './CardArq';
import CardArtesnia from "./CardArtesnia";
import CardMuseo from "./CardMuseo"; // lo usas para museos y cooperativas
import CardPuebloMagico from './CardPuebloMagico';
import CardTour from './CardTour';
import CardHospedaje from './CardHospedaje';
import RestaurantCard from '../components/Tab2/RestaurantCard';
import CardPlatilloQRoo from './CardPlatilloQRoo';
import CardTurCom from './CardTurCom';
import CardExpYucatan from './CardExpYucatan';
import CardSabYucatan from './CardSabYucatan'; // <-- si tu componente se llama distinto ajusta aquí

// Nota: si CardSabYucado no existe, cámbialo por CardSabYucatan o el nombre correcto.
// (En tu versión inicial usabas CardSabYucatan — ajusta según tu archivo.)

const Modal: React.FC<Tipo> = ({ match }) => {
  const router = useIonRouter();
  const [t, i18n] = useTranslation("global");
  const [searchText, setSearchText] = useState('');

  const langEnable = i18n.language;

  // Selección de datos multilanguage para turcom y sitios arqueológicos
  let dataTurCom = dataTurComMaya;
  let dataSitiosArq = dataSitiosArqEsp;
  let dataArtesanias = dataArtesaniasEsp;
  let dataMuseos = dataMuseosEsp;
  let dataPueblosMagicos = dataPueblosMagicosEsp;
  let dataCooperativas = dataCooperativasEsp;
  let dataTours = dataToursEsp;
  let dataHospedaje = dataHospedajeEsp;
  let dataRestaurante = dataRestauranteEsp;
  let dataPlatilloQRoo = dataPlatilloQRooEsp;

  switch (langEnable) {
    case 'es':
      dataTurCom = dataTurComEsp;
      dataSitiosArq = dataSitiosArqEsp;
      dataArtesanias = dataArtesaniasEsp;
      dataMuseos = dataMuseosEsp;
      dataPueblosMagicos = dataPueblosMagicosEsp;
      dataCooperativas = dataCooperativasEsp;
      dataTours = dataToursEsp;
      dataHospedaje = dataHospedajeEsp;
      dataRestaurante = dataRestauranteEsp;
      dataPlatilloQRoo = dataPlatilloQRooEsp;
      break;
    case 'en':
      dataTurCom = dataTurComEng;
      dataSitiosArq = dataSitiosArqEng;
      dataArtesanias = dataArtesaniasEng;
      dataMuseos = dataMuseosEng;
      dataPueblosMagicos = dataPueblosMagicosEng;
      dataCooperativas = dataCooperativasEng;
      dataTours = dataToursEng;
      dataHospedaje = dataHospedajeEng;
      dataRestaurante = dataRestauranteEng;
      dataPlatilloQRoo = dataPlatilloQRooEng;
      break;
    case 'fr':
      dataTurCom = dataTurComFren;
      dataSitiosArq = dataSitiosArqFren;
      dataArtesanias = dataArtesaniasFren;
      dataMuseos = dataMuseosFren;
      dataPueblosMagicos = dataPueblosMagicosFren;
      dataCooperativas = dataCooperativasFren;
      dataTours = dataToursFren;
      dataHospedaje = dataHospedajeFren;
      dataRestaurante = dataRestauranteFren;
      dataPlatilloQRoo = dataPlatilloQRooFren;
      break;
    case 'zh':
      dataTurCom = dataTurComChin;
      dataSitiosArq = dataSitiosArqChin;
      dataArtesanias = dataArtesaniasChin;
      dataMuseos = dataMuseosChin;
      dataPueblosMagicos = dataPueblosMagicosChin;
      dataCooperativas = dataCooperativasChin;
      dataTours = dataToursChin;
      dataHospedaje = dataHospedajeChin;
      dataRestaurante = dataRestauranteChin;
      dataPlatilloQRoo = dataPlatilloQRooChin;
      break;
    case 'maya':
      dataTurCom = dataTurComMaya;
      dataSitiosArq = dataSitiosArqMaya;
      dataArtesanias = dataArtesaniasMaya;
      dataMuseos = dataMuseosMaya;
      dataPueblosMagicos = dataPueblosMagicosMaya;
      dataCooperativas = dataCooperativasMaya;
      dataTours = dataToursMaya;
      dataHospedaje = dataHospedajeMaya;
      dataRestaurante = dataRestauranteMaya;
      dataPlatilloQRoo = dataPlatilloQRooMaya;
      break;
  }

  // Helper: obtiene string del campo (maneja arrays)

  
  const getFieldString = (item: any, field: string) => {
    const val = item[field];
    if (val === undefined || val === null) return '';
    if (Array.isArray(val)) return val.join(' ');
    return String(val);
  };

  // Función de filtrado genérica
  const filterData = (data: any[], fields: string[]) => {
    if (!searchText || searchText.trim() === '') return data;
    const q = searchText.toLowerCase();
    return data.filter(item =>
      fields.some(field => getFieldString(item, field).toLowerCase().includes(q))
    );
  };

  // Filtrados por sección (con los campos que solicitaste)
  const filteredArq = filterData(dataSitiosArq, ['nombre', 'descripcion', 'municipio']);
  const filteredPlatillos = filterData(dataPlatilloQRoo, ['nombrePlatillo', 'localidad', 'estado', 'descripcion', 'ingredientes']);
  const filteredTours = filterData(dataTours, ['titulo', 'actividades', 'incluye']);
  const filteredArtesanias = filterData(dataArtesanias, ['nombreautor', 'nombrepieza', 'localidad', 'descripcion', 'historia', 'procesoproduccion']);
  const filteredRestaurantes = filterData(dataRestaurante, ['nombre', 'direccion']);
  const filteredPueblos = filterData(dataPueblosMagicos, ['nombre', 'municipio', 'descripcion', 'caracteristicas', 'atractivos', 'festividades', 'ubicacion']);
  const filteredHospedaje = filterData(dataHospedaje, ['nombre', 'direccion', 'incluye']);
  const filteredCooperativas = filterData(dataCooperativas, ['nombre', 'municipio', 'descripcion']);
  const filteredTurCom = filterData(dataTurCom, ['nombre', 'empresa', 'localidad', 'estado', 'titulo', 'programa', 'descripcion', 'actividades', 'incluye']);
  const filteredExpYuc = filterData(dataExpYucatan, ['lugar', 'nombre', 'nombre_corto', 'informacion', 'regiones', 'descripcion', 'actividades', 'distancias', 'sugerido_para']);
  const filteredSabYuc = filterData(dataSabYucatan, ['lugar', 'nombre', 'nombre_corto', 'informacion', 'regiones', 'descripcion', 'datos_interes', 'distancias']);
  const filteredMuseos = filterData(dataMuseos, ['nombre', 'localidad', 'municipio']);

  // Reusable header + searchbar
  const renderHeaderWithSearch = (titleText: string, className = '') => (
    <IonHeader translucent={true}>
      <IonToolbar className={`${className} header-titles`}>
        <IonButtons slot='start'>
          <IonButton onClick={(e) => { e.preventDefault(); router.push('/app/tabs/tab1', 'back'); }} color='light'>
            <IonIcon icon={arrowBack} size='medium' />
          </IonButton>
        </IonButtons>
        <IonTitle>{titleText}</IonTitle>
      </IonToolbar>

      <IonToolbar>
        <IonSearchbar
          value={searchText}
          onIonInput={(e) => setSearchText(e.detail.value ?? '')}
          debounce={300}
          placeholder={t("Buscar...") || "Buscar..."}
        />
      </IonToolbar>
    </IonHeader>
  );

  return (
    <React.Suspense>
      <IonPage>

        {/* ARQUEOLOGÍA (con props explícitos, como pediste) */}
        {match.params.nom === "arqueologia" && (
          <>
            {renderHeaderWithSearch(t("arqueologia.title"), 'Arqueologia')}
            <IonContent fullscreen={true}>
              {filteredArq.map((Arq) => (
                <CardArq
                  key={Arq.nombre}
                  nombre={Arq.nombre}
                  traduccion={Arq.traduccion}
                  municipio={Arq.municipio}
                  latitud={Arq.latitud}
                  longitud={Arq.longitud}
                  descripcion={Arq.descripcion}
                  horario={Arq.horario}
                  sitio_web={Arq.sitio_web}
                  precio={Arq.precio}
                  tipo={Arq.tipo}
                  promocion={Arq.promocion}
                  urlImagen={Arq.urlImagen}
                  duracion_visita={Arq.duracion_visita}
                  cronologia={Arq.cronologia}
                  func_original={Arq.func_original}
                  mitos={Arq.mitos}
                  eventos_historicos={Arq.eventos_historicos}
                  descubrimiento={Arq.descubrimiento}
                  estructuras_iconicas={Arq.estructuras_iconicas}
                  rutas_sugeridas={Arq.rutas_sugeridas}
                  colecciones_destacadas={Arq.colecciones_destacadas}
                  accesibilidad={Arq.accesibilidad}
                  instalaciones={Arq.instalaciones}
                  recomendaciones={Arq.recomendaciones}
                  reconocimientos={Arq.reconocimientos}
                />
              ))}

              {filteredArq.length === 0 && (
                <p style={{ textAlign: "center", marginTop: "1rem" }}>
                  {t("noResultados") || "No se encontraron resultados."}
                </p>
              )}
            </IonContent>
          </>
        )}

        {/* PLATILLOS (props explícitos) */}
        {match.params.nom === "platillos" && (
          <>
            {renderHeaderWithSearch(t("platillos.title"), 'Platillos')}
            <IonContent fullscreen={true}>
              {filteredPlatillos.map((platqroo) => (
                <CardPlatilloQRoo
                  key={platqroo.nombrePlatillo}
                  nombrePlatillo={platqroo.nombrePlatillo}
                  chef={platqroo.chef}
                  localidad={platqroo.localidad}
                  estado={platqroo.estado}
                  latitud={platqroo.latitud}
                  longitud={platqroo.longitud}
                  descripcion={platqroo.descripcion}
                  imagenPlatillo={platqroo.imagenPlatillo}
                  ingredientes={platqroo.ingredientes}
                  imagenesIngredientes={platqroo.imagenesIngredientes}
                  procedimiento={platqroo.procedimiento}
                />
              ))}

              {filteredPlatillos.length === 0 && (
                <p style={{ textAlign: "center", marginTop: "1rem" }}>
                  {t("noResultados") || "No se encontraron platillos."}
                </p>
              )}
            </IonContent>
          </>
        )}

        {/* TOURS */}
        {match.params.nom === "tours" && (
          <>
            {renderHeaderWithSearch(t("tours.title"), 'Tours')}
            <IonContent fullscreen={true}>
              {filteredTours.map((tour) => (
                <CardTour
                  key={tour.titulo}
                  estacion={tour.estacion}
                  titulo={tour.titulo}
                  imgPortada={tour.imgPortada}
                  precio={tour.precio}
                  sitioWeb={tour.sitioWeb}
                  actividades={tour.actividades}
                  imgActividades={tour.imgActividades}
                  telefono={tour.telefono}
                  incluye={tour.incluye}
                />
              ))}

              {filteredTours.length === 0 && (
                <p style={{ textAlign: "center", marginTop: "1rem" }}>
                  {t("noResultados") || "No se encontraron tours."}
                </p>
              )}
            </IonContent>
          </>
        )}

        {/* ARTESANÍAS */}
        {match.params.nom === "artesanias" && (
          <>
            {renderHeaderWithSearch(t("artesanias.title"), 'Artesanias')}
            <IonContent fullscreen={true}>
              {filteredArtesanias.map((artesania) => (
                <CardArtesnia
                  key={artesania.nombrepieza+artesania.nombreautor}
                  nombreAutor={artesania.nombreautor}
                  nombrePieza={artesania.nombrepieza}
                  localidad={artesania.localidad}
                  descripcion={artesania.descripcion}
                  historia={artesania.historia}
                  proceso={artesania.procesoproduccion}
                  precio={artesania.precio}
                  urlImg={artesania.urlImagen}
                />
              ))}

              {filteredArtesanias.length === 0 && (
                <p style={{ textAlign: "center", marginTop: "1rem" }}>
                  {t("noResultados") || "No se encontraron artesanías."}
                </p>
              )}
            </IonContent>
          </>
        )}

        {/* RESTAURANTES */}
        {match.params.nom === "restaurantes" && (
          <>
            {renderHeaderWithSearch(t("restaurantes.title"), 'Restaurantes')}
            <IonContent fullscreen={true}>
              {filteredRestaurantes.map((restaurante) => (
                <RestaurantCard
                  key={restaurante.nombre}
                  nombre={restaurante.nombre}
                  direccion={restaurante.direccion}
                  imageUrl={restaurante.urlImagen}
                  calificacion={restaurante.calificacion}
                  open={restaurante.horario}
                />
              ))}

              {filteredRestaurantes.length === 0 && (
                <p style={{ textAlign: "center", marginTop: "1rem" }}>
                  {t("noResultados") || "No se encontraron restaurantes."}
                </p>
              )}
            </IonContent>
          </>
        )}

        {/* MUSEOS */}
        {match.params.nom === "museos" && (
          <>
            {renderHeaderWithSearch(t("museos.title"), 'Museos')}
            <IonContent fullscreen={true}>
              {filteredMuseos.map((Mus) => (
                <CardMuseo
                  key={Mus.nombre}
                  nombre={Mus.nombre}
                  municipio={Mus.municipio}
                  descripcion={Mus.descripcion}
                  horario={Mus.horario}
                  sitio_web={Mus.sitio_web}
                  precio={Mus.precio}
                  tipo={Mus.tipo}
                  urlImagen={Mus.urlImagen}
                  promocion={Mus.promocion}
                />
              ))}
              {filteredMuseos.length === 0 && (
                <p style={{ textAlign: "center", marginTop: "1rem" }}>
                  {t("noResultados") || "No se encontraron museos."}
                </p>
              )}
            </IonContent>
          </>
        )}

        {/* PUEBLOS MÁGICOS */}
        {match.params.nom === "pueblosmagicos" && (
          <>
            {renderHeaderWithSearch(t("pueblosmagicos.title"), 'Pueblos Mágicos')}
            <IonContent fullscreen={true}>
              {filteredPueblos.map((PMag) => (
                <CardPuebloMagico
                  key={PMag.nombre}
                  nombre={PMag.nombre}
                  traduccion={PMag.traduccion}
                  municipio={PMag.municipio}
                  latitud={PMag.latitud}
                  longitud={PMag.longitud}
                  descripcion={PMag.descripcion}
                  horario={PMag.horario}
                  sitio_web={PMag.sitio_web}
                  precio={PMag.precio}
                  tipo={PMag.tipo}
                  promocion={PMag.promocion}
                  urlImagen={PMag.urlImagen}
                  caracteristicas={PMag.caracteristicas}
                  atractivos={PMag.atractivos}
                  festividades={PMag.festividades}
                  ubicacion={PMag.ubicacion}
                />
              ))}

              {filteredPueblos.length === 0 && (
                <p style={{ textAlign: "center", marginTop: "1rem" }}>
                  {t("noResultados") || "No se encontraron pueblos mágicos."}
                </p>
              )}
            </IonContent>
          </>
        )}

        {/* HOSPEDAJE */}
        {match.params.nom === "hospedaje" && (
          <>
            {renderHeaderWithSearch(t("hostage.title"), 'Hospedajes')}
            <IonContent fullscreen={true}>
              {filteredHospedaje.map((hospedaje) => (
                <CardHospedaje
                  key={hospedaje.nombre}
                  nombre={hospedaje.nombre}
                  direccion={hospedaje.direccion}
                  telefono={hospedaje.telefono}
                  urlImage={hospedaje.URLimagen}
                  precio={hospedaje.precio_habitacion_sencilla}
                  resena={hospedaje.resena}
                  calificacion={hospedaje.calificacion}
                  incluye={hospedaje.incluye}
                  imgActividades={hospedaje.imgActividades}
                />
              ))}

              {filteredHospedaje.length === 0 && (
                <p style={{ textAlign: "center", marginTop: "1rem" }}>
                  {t("noResultados") || "No se encontraron hospedajes."}
                </p>
              )}
            </IonContent>
          </>
        )}

        {/* COOPERATIVAS */}
        {match.params.nom === "cooperativas" && (
          <>
            {renderHeaderWithSearch(t("cooperativas.title"), 'Cooperativas')}
            <IonContent fullscreen={true}>
              {filteredCooperativas.map((Mus) => (
                <CardMuseo
                  key={Mus.nombre}
                  nombre={Mus.nombre}
                  municipio={Mus.municipio}
                  descripcion={Mus.descripcion}
                  horario={Mus.horario}
                  sitio_web={Mus.sitio_web}
                  precio={Mus.precio}
                  tipo={Mus.tipo}
                  urlImagen={Mus.urlImagen}
                  promocion={Mus.promocion}
                />
              ))}

              {filteredCooperativas.length === 0 && (
                <p style={{ textAlign: "center", marginTop: "1rem" }}>
                  {t("noResultados") || "No se encontraron cooperativas."}
                </p>
              )}
            </IonContent>
          </>
        )}

        {/* TURISMO COMUNITARIO (TURCOM) */}
        {match.params.nom === "turcom" && (
          <>
            {renderHeaderWithSearch(t("turcom.title"), 'TurCom')}
            <IonContent fullscreen={true}>
              {filteredTurCom.map((TurCom) => (
                <CardTurCom
                  key={TurCom.titulo || TurCom.id || TurCom.nombre}
                  id={TurCom.id}
                  nombre={TurCom.nombre}
                  empresa={TurCom.empresa}
                  localidad={TurCom.localidad}
                  estado={TurCom.estado}
                  titulo={TurCom.titulo}
                  programa={TurCom.programa}
                  latitud={TurCom.latitud}
                  longitud={TurCom.longitud}
                  heroImage={TurCom.heroImage}
                  sitioWeb={TurCom.sitioWeb}
                  descripcion={TurCom.descripcion}
                  actividades={TurCom.actividades}
                  imagenes={TurCom.imagenes}
                  datos_contacto={TurCom.datos_contacto}
                  incluye={TurCom.incluye}
                />
              ))}

              {filteredTurCom.length === 0 && (
                <p style={{ textAlign: "center", marginTop: "1rem" }}>
                  {t("noResultados") || "No se encontraron resultados."}
                </p>
              )}
            </IonContent>
          </>
        )}

        {/* EXPERIENCIAS YUCATÁN */}
        {match.params.nom === "expyuc" && (
          <>
            {renderHeaderWithSearch(t("experienciasyucatan.title"), 'Experiencias')}
            <IonContent fullscreen={true}>
              {filteredExpYuc.map((ExpYucatan) => (
                <CardExpYucatan
                  key={ExpYucatan.nombre}
                  id={ExpYucatan.id}
                  lugar={ExpYucatan.lugar}
                  nombre={ExpYucatan.nombre}
                  imagen_prin={ExpYucatan.imagen_prin}
                  nombre_corto={ExpYucatan.nombre_corto}
                  informacion={ExpYucatan.informacion}
                  regiones={ExpYucatan.regiones}
                  imagenes={ExpYucatan.imagenes}
                  descripcion={ExpYucatan.descripcion}
                  actividades={ExpYucatan.actividades}
                  distancias={ExpYucatan.distancias}
                  sugerido_para={ExpYucatan.sugerido_para}
                  latitud={ExpYucatan.latitud}
                  longitud={ExpYucatan.longitud}
                />
              ))}

              {filteredExpYuc.length === 0 && (
                <p style={{ textAlign: "center", marginTop: "1rem" }}>
                  {t("noResultados") || "No se encontraron experiencias."}
                </p>
              )}
            </IonContent>
          </>
        )}

        {/* SABORES YUCATÁN */}
        {match.params.nom === "sabyuc" && (
          <>
            {renderHeaderWithSearch(t("saboresyucatan.title"), 'Sabores')}
            <IonContent fullscreen={true}>
              {filteredSabYuc.map((SabYuc) => (
                <CardSabYucatan
                  key={SabYuc.nombre}
                  id={SabYuc.id}
                  lugar={SabYuc.lugar}
                  nombre={SabYuc.nombre}
                  imagen_prin={SabYuc.imagen_prin}
                  nombre_corto={SabYuc.nombre_corto}
                  informacion={SabYuc.informacion}
                  regiones={SabYuc.regiones}
                  imagenes={SabYuc.imagenes}
                  descripcion={SabYuc.descripcion}
                  datos_interes={SabYuc.datos_interes}
                  distancias={SabYuc.distancias}
                  latitud={SabYuc.latitud}
                  longitud={SabYuc.longitud}
                />
              ))}

              {filteredSabYuc.length === 0 && (
                <p style={{ textAlign: "center", marginTop: "1rem" }}>
                  {t("noResultados") || "No se encontraron sabores."}
                </p>
              )}
            </IonContent>
          </>
        )}

      </IonPage>
    </React.Suspense>
  );
};

export default Modal;
